import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableBrandedSMS = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enableBrandedSMS);
};
